<mat-card *ngIf="!updateMode">Add menu item</mat-card>
<mat-card *ngIf="updateMode">Update menu item</mat-card>

<div align="end" class="row" style="padding:10px 10px 0 0;">
  <!-- <span class="spacer"></span> -->
 
  <button mat-raised-button color="primary" (click)="submit()">
    <mat-icon>done</mat-icon>
    {{'submit' | translate}}</button>
    &nbsp;
  <button mat-raised-button (click)="back()">
    <mat-icon>keyboard_backspace</mat-icon>
    {{'back' | translate}}</button>
    &nbsp;
</div>


<mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile> 
        <mat-form-field  appearance="standard">
        <mat-label>menus</mat-label>
        <mat-select [(value)]="menuItem.menu_id">
          <mat-option *ngFor="let item of menus" [value]="item.id">
            {{item.name}}
          </mat-option>
        </mat-select>
    </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
        <mat-form-field  appearance="standard">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="menuItem.name" required #arabName="ngModel">
            <mat-error *ngIf="arabName.invalid">{{'requiredField' | translate}}</mat-error>
          </mat-form-field>
          
    </mat-grid-tile>
    <mat-grid-tile>
        <mat-form-field  appearance="standard">
            <mat-label>Link</mat-label>
            <input matInput [(ngModel)]="menuItem.link" required #engName="ngModel">
            
          </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
        <mat-form-field  appearance="standard">
            <mat-label>Icon</mat-label>
            <input matInput [(ngModel)]="menuItem.icon" required >
          </mat-form-field>
    </mat-grid-tile>
   
  
  </mat-grid-list>
    

  <app-matspinner [overlay]="spinnerOverlay"></app-matspinner>
